import React from 'react';

import I18N from 'assets/i18n/brandlift-project';

import Block from 'client/common/components/block';
import SizeWrapper from 'client/common/components/audience-settings/size-wrapper/size-wrapper';

import {AudienceSizeDO} from 'client/common/utils/audience';
import {useSurveySlug} from 'client/common/contexts/slug';
import {useAudienceRequest} from 'client/common/hooks/audience';
import {useBoxType} from 'client/common/hooks/box';
import {useUserRoles} from 'client/common/hooks/user';

const i18n = I18N.surveyEditor;

interface SizeBlockProps {
    description?: string;
}

// eslint-disable-next-line max-statements
export default function SizeBlock(props: SizeBlockProps) {
    const {description} = props;
    const slug = useSurveySlug();
    const boxType = useBoxType(slug);
    const request = useAudienceRequest(slug);
    const userRoles = useUserRoles();

    if (request.status !== 'success') {
        return null;
    }

    const isVisible = AudienceSizeDO.isSizeInputVisible({type: request.data.type});

    if (!isVisible) {
        return null;
    }

    const isInputEnabled = AudienceSizeDO.isSizeInputEnabled({boxType, userRoles});

    return (
        <Block header={i18n.sizeBlock.title} description={description ?? i18n.sizeBlock.description}>
            {request.status === 'success' && (
                <SizeWrapper request={request.data} slug={slug} disabled={!isInputEnabled} />
            )}
        </Block>
    );
}
